<template>
    <div id="anchorageStagesDiv" class="ortho-controls">
        <button class="anchorage-button anchorage-video-button" v-on:click="generateVideoClick()">
            GENERATE VIDEO
        </button>
        <img id="anchorageSaveImg" class="anchorage-save-img" src="images/dark-blue-spinner.gif" />

        <div id="anchorageSliderCont" class="anchorage-video-invisible">
            <div id="anchorageSlider" class="horizontal-slider"></div>

            <img id="anchorageSliderPlayBtn" class="anchorage-play-img" v-on:click="switchPlayClick()"
                :src="mode.isPlaying ? 'images/pause.png' : 'images/play.png'" />
            <img id="anchorageSliderCloseBtn" class="anchorage-play-img" v-on:click="closeClick()"
                :src="mode.isWhite ? 'images/cross.png' : 'images/cross.png'" />
        </div>

        <div id="anchorageStagesNums" class="anchorage-video-invisible">
            <!-- <button v-for="(stage, index) in mode.stages" :key="stage.name"
                v-bind:style="{ left: 'calc(' + index * proportion + '% - 17px)' }"
                v-on:click="clickAnchorageStage(stage.id)" :title="stage.name"
                class="anchorage-stage anchorage-stage-mid ui-button ui-widget ui-corner-all">
                {{ "S" + stage.id }}
            </button> -->

            <span v-for="(stage, index) in mode.stages" :key="stage.id"
                v-bind:style="{ left: 'calc(' + index * proportion + '% - 8px)', top: '-31px' }"
                v-on:click="clickAnchorageStage(stage.id)" :title="stage.name"
                class="ui-slider-handle ui-corner-all ui-state-default anchorage-ellipse"></span>

        </div>

    </div>
</template>

<script>

import {
    applyAnchorageStage,
    switchAnchoragePlay,
    generateVideo,
    leaveAnchorageAnimationMode
} from "./AnchorageAnimation.js";

export default {
    name: "AnchorageStages",
    props: {
        mode: {
            type: Object,
            required: true
        },
    },
    data() {
        return {};
    },
    methods: {
        generateVideoClick: function () {
            generateVideo();
        },
        switchPlayClick: function () {
            switchAnchoragePlay(!vueApp.isTreatmentPlaying);
        },
        clickAnchorageStage: function (stageId) {
            applyAnchorageStage(stageId);
            this.mode.isPlaying = false;
            switchAnchoragePlay(false);
        },
        closeClick: function () {
            leaveAnchorageAnimationMode();
        },
    },
    computed: {
        proportion: function () {
            return 100 / (this.mode.stages.length - 1);
        }
    },
    mounted: function () {
        console.log("AnchorageStages mounted", this.mode);
    }
};

</script>

<style>
/* @import "../../css/jquery-ui.css"; */

#anchorageStagesDiv {
    position: absolute;
    text-align: center;
    left: 10px;
    bottom: 65px;
    z-index: 999;
    display: block;
    width: calc(100% - 215px);
    height: 70px;
}

.anchorage-button {
    min-width: 90px;
    width: auto;
    height: 35px;
    border: 0;
    cursor: pointer;
    font-size: small;
    background-color: #4687fc;
    text-align: center;
    color: #ffffff;
}

.anchorage-video-button {
    position: absolute;
    width: 140px;
    bottom: 70px;
    left: calc(50% + 20px);
}

.anchorage-save-img {
    display: none;
    position: absolute;
    width: 35px;
    height: 35px;
    bottom: 70px;
    left: calc(50% + 160px);
}

#anchorageSliderCont {
    text-align: center;
    white-space: nowrap;
    width: 100%;
    height: 35px;
}

#anchorageStagesNums {
    position: absolute;
    text-align: center;
    white-space: nowrap;
    width: calc(100% - 105px);
    height: 35px;
    top: 40px;
    left: 15px;
}

.anchorage-stage {
    position: absolute;
    padding: 2px;
    font-size: small;
    width: 65px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.anchorage-stage-mid {
    width: 27px;
}

.anchorage-ellipse {
    position: absolute;
    padding: 3px;
    height: 25px;
}

.horizontal-slider {
    border: 1px solid #c5c5c5;
    /*position: relative;*/
    width: calc(100% - 105px);
    border-radius: 0;
    outline: none;
    height: 0.4em;
    margin-left: 5px;
    margin-right: 5px;
    display: inline-block;
    color: #333333;
    background: #ffffff;
}

.horizontal-slider .ui-slider-range {
    display: none;
}

.horizontal-slider .ui-slider-handle {
    outline: none;
    width: 1.6em;
    height: 1.6em;
    border-radius: 30px;
    top: -0.6em;
    margin-left: -0.9em;
}

.anchorage-play-img {
    width: 40px;
    cursor: pointer;
    display: inline-block;
}

#anchorageSliderPlayBtn {
    margin-left: 2px;
}

#originalTreatmentStage {
    left: -15px;
    width: 55px;
}

@media screen and (max-width: 650px) {
    #anchorageStagesDiv {
        left: 5px;
        bottom: 60px;
        width: calc(100% - 5px);
    }

    .anchorage-stage {
        padding: 1px;
    }

    #originalTreatmentStage {
        width: 27px;
    }
}
</style>